module.exports = __webpack_public_path__ + "img/public/SiteIcons/sliderPrevArrow.svg?57c9f0d6";